//
import { alpha } from '@mui/material/styles';
import { CloseIcon } from './CustomIcons';

// ----------------------------------------------------------------------

export default function Chip(theme) {
  return {
    MuiChip: {
      defaultProps: {
        deleteIcon: <CloseIcon />,
      },
      styleOverrides: {
        root: ({ ownerState }) => {
          // Rounded rectangles rather than pills, matching Distributions.
          let styles = { borderRadius: theme.shape.borderRadius };
          if (
            ownerState.color === 'primary' &&
            ownerState.variant === 'ghost'
          ) {
            styles = {
              ...styles,
              backgroundColor: theme.palette.grey[200],
              color: theme.palette.primary.main,
              fontWeight: theme.typography.fontWeightBold,
            };
          }
          if (ownerState.fullWidth) {
            styles = {
              ...styles,
              width: '100%',
            };
          }
          return styles;
        },
        colorDefault: {
          '& .MuiChip-avatarMedium, .MuiChip-avatarSmall': {
            color: theme.palette.text.secondary,
          },
        },
        // Colored outlined chips are status labels: tint them like the CRM and
        // Distributions chips so light palette colors (success, warning) stay
        // legible on white instead of rendering as faint text in a grey outline.
        outlined: ({ ownerState }) => {
          const color = theme.palette[ownerState.color];
          if (ownerState.color === 'default' || !color?.main) {
            return { borderColor: theme.palette.grey[500_48] };
          }
          return {
            borderColor: alpha(color.main, 0.4),
            backgroundColor: alpha(color.main, 0.08),
            color: color.dark,
            fontWeight: theme.typography.fontWeightMedium,
            '& .MuiChip-icon': { color: color.dark },
            '&.MuiChip-clickable:hover': {
              backgroundColor: alpha(color.main, 0.16),
            },
          };
        },
        //
        avatarColorInfo: {
          color: theme.palette.info.contrastText,
          backgroundColor: theme.palette.info.dark,
        },
        avatarColorSuccess: {
          color: theme.palette.success.contrastText,
          backgroundColor: theme.palette.success.dark,
        },
        avatarColorWarning: {
          color: theme.palette.warning.contrastText,
          backgroundColor: theme.palette.warning.dark,
        },
        avatarColorError: {
          color: theme.palette.error.contrastText,
          backgroundColor: theme.palette.error.dark,
        },
      },
    },
  };
}
